import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=a5b8ddbe&scoped=true&"
import script from "./userManagement.vue?vue&type=script&lang=js&"
export * from "./userManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b8ddbe",
  null
  
)

export default component.exports